import React, { useMemo, useState, useRef, useEffect } from "react";
import style from "../Chat.module.css";
import imgAvata from '../../../../images/common/img_chat_mascot.svg';

function InputBoxMessage({ chatInfo, onSubmit }) {
    const initialValues = useMemo(() => {
        const result = {};

        (chatInfo.inputs || []).forEach((input, index) => {
            // result[index] = input.value ?? "";
            
            // 드롭다운은 값이 없으면 첫 항목을 기본 선택으로 둔다
            result[index] =
                input.value 
                        ?? (input.type === "dropdown"
                        ? (input.options?.selections?.[0] ?? "")
                        : "");
        });

        return result;
    }, [chatInfo.inputs]);

    const [values, setValues] = useState(initialValues);
    const [submitted, setSubmitted] = useState(
        chatInfo.submitted === true || chatInfo.isHistory === true
    );

    // 열려 있는 드롭다운의 index. 없으면 null
    const [openIndex, setOpenIndex] = useState(null);
    const selectWrapRef = useRef(null);

    // inputs 가 나중에 도착하면 기본값을 다시 채운다
    useEffect(() => {
        if (submitted) return;
        setValues(initialValues);
    }, [initialValues, submitted]);

    // 바깥 클릭 시 닫기
    useEffect(() => {
        if (openIndex === null) return;

        const handle = (e) => {
            if (!selectWrapRef.current?.contains(e.target)) {
                setOpenIndex(null);
            }
        };

        document.addEventListener('mousedown', handle);
        return () => document.removeEventListener('mousedown', handle);
    }, [openIndex]);

    const handleChange = (index, value) => {
        setValues(prev => ({
            ...prev,
            [index]: value,
        }));
    };

    const handleSubmit = () => {
        if (submitted) {
            return;
        }

        const result = {};

        (chatInfo.inputs || []).forEach((input, index) => {
            const value = values[index];

            result[input.label] =
                input.type === "number"
                    ? Number(value)
                    : value;
        });

        setSubmitted(true);
        onSubmit(chatInfo.id, result);
    };

    return (
        <div className={style["ai-talk-box"]}>
            <strong className={style['ai-avatar']}>
                <img src={imgAvata} alt="ai 아바타" />
            </strong>

            <div className={style["ai-box"]}>
                <div className={style["text-box"]}>
                    <div className={style["p-group"]}>
                        {chatInfo.messageTitle && (
                            <strong>{chatInfo.messageTitle}</strong>
                        )}

                        {chatInfo.text && (
                            <p>{chatInfo.text}</p>
                        )}
                    </div>
                </div>

                {(chatInfo.tables || []).map((table, tableIndex) => (
                    <div
                        key={tableIndex}
                        className={style["input-table-wrap"]}
                        data-class='a'
                    >
                        {table.table_title && (
                            <strong>{table.table_title}</strong>
                        )}

                        <table className={style["input-table"]} data-table="ai-message">
                            <thead>
                                <tr>
                                    <th>항목</th>
                                    <th>값</th>
                                </tr>
                            </thead>

                            <tbody>
                                {(table.rows || []).map((row, rowIndex) => (
                                    <tr key={rowIndex}>
                                        <td>{row.column}</td>
                                        <td>{row.value}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ))}

                <div className={style["input-field-list"]}>
                    {(chatInfo.inputs || []).map((input, index) => (
                        <div
                            key={`${input.label}-${index}`}
                            className={style["input-field-row"]}
                        >
                            {/* <label htmlFor={`ai-input-${chatInfo.id}-${index}`}>
                                {input.label}
                            </label> */}
                            {input.type === "dropdown" ? (
                                <span className={style["input-field-label"]}>{input.label}</span>
                            ) : (
                                <label htmlFor={`ai-input-${chatInfo.id}-${index}`}>
                                    {input.label}
                                </label>
                            )}

                            {input.type === "number" && (
                                <div className={style["input-num-write-box"]}>
                                    
                                    <input
                                        id={`ai-input-${chatInfo.id}-${index}`}
                                        type="number"
                                        value={values[index] ?? ""}
                                        min={input.options?.lower}
                                        max={input.options?.upper}
                                        disabled={submitted}
                                        onChange={(e) =>
                                            handleChange(index, e.target.value)
                                        }
                                    />

                                    {input.options?.unit && (
                                        <span>
                                            {input.options.unit}
                                        </span>
                                    )}
                                </div>
                            )}

                            {input.type === "dropdown" && (
                                // <select
                                //     id={`ai-input-${chatInfo.id}-${index}`}
                                //     value={values[index] ?? ""}
                                //     disabled={submitted}
                                //     onChange={(e) =>
                                //         handleChange(index, e.target.value)
                                //     }
                                // >
                                //     {(input.options?.selections || []).map(
                                //         option => (
                                //             <option
                                //                 key={option}
                                //                 value={option}
                                //             >
                                //                 {option}
                                //             </option>
                                //         )
                                //     )}
                                // </select>

                                <div
                                    ref={openIndex === index ? selectWrapRef : null}
                                    className={style["chat-select"]}
                                    data-open={openIndex === index ? "true" : undefined}
                                    data-disabled={submitted ? "true" : undefined}
                                    onClick={() => {
                                        if (submitted) return;
                                        setOpenIndex(prev => (prev === index ? null : index));
                                    }}
                                >
                                    <span className={style["chat-select-label"]}>
                                        {values[index] || "선택"}
                                    </span>

                                    <div className={style["chat-select-scroll"]}>
                                        <ul>
                                            {(input.options?.selections || []).map(option => (
                                                <li
                                                    key={option}
                                                    data-selected={values[index] === option ? "true" : undefined}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleChange(index, option);
                                                        setOpenIndex(null);
                                                    }}
                                                >
                                                    {option}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            )}
                        </div>
                    ))}
                </div>

                <button
                    type="button"
                    className={style["input-submit-btn"]}
                    disabled={submitted}
                    onClick={handleSubmit}
                >
                    <span>{submitted ? "입력 완료" : "확인"}</span>
                </button>

                <span className={style["date-txt"]}>
                    {chatInfo.chatTime}
                </span>
            </div>
        </div>
    );
}

export default React.memo(InputBoxMessage);